import { MockDebug } from '@tino-frontend/mocks'
import oneInvoice from '@fixtures/apis/invoices/core/company-id-invoices/one-invoice.json'
import listCoreOneInvoice from '@fixtures/apis/invoices/core/list-one-invoice.json'
import listCoreOneInstallment from '@fixtures/apis/invoices/core/list-one-installment.json'
import listCoreTwoInstallments from '@fixtures/apis/invoices/core/list-two-installments.json'
import listCoreThreeInstallments from '@fixtures/apis/invoices/core/list-three-installments.json'
import listCoreCanceled from '@fixtures/apis/invoices/core/list-canceled.json'
import listCoreEdited from '@fixtures/apis/invoices/core/list-edited.json'
import listCorePendingInvoiceInstallments from '@fixtures/apis/invoices/core/list-pending-invoice.json'

import { genericErrorMock } from '@fixtures/apis/generic-error'
import { listOneInstallmentMock } from '@fixtures/apis/invoices/merchant-bff/list-one-installment'
import { listOneInstallmentWithoutServiceFeeMock } from '@fixtures/apis/invoices/merchant-bff/list-one-installment-without-service-fee'
import { listAllStatusMock } from '@fixtures/apis/invoices/merchant-bff/list-all-status'
import { listBoletoCanceledMock } from '@fixtures/apis/invoices/merchant-bff/list-boleto-canceled'
import { listBoletoDownloadMock } from '@fixtures/apis/invoices/merchant-bff/list-boleto-download'
import { listEditedMock } from '@fixtures/apis/invoices/merchant-bff/list-edited'
import { listWithoutTaxNumberMock } from '@fixtures/apis/invoices/merchant-bff/list-without-tax-invoice-number'
import { listReimbursedMock } from '@fixtures/apis/invoices/merchant-bff/list-installment-reimbursed'
import {
  REACT_APP_CORE_API_URL,
  REACT_APP_MERCHANT_BFF_API_URL,
  REACT_APP_SUPPLIER_BFF_API_URL,
} from 'constants/envs'
import { invoice as invoiceMock } from '@fixtures/apis/invoices/supplier-bff'
import { listDebitMock } from '@fixtures/apis/invoices/merchant-bff/list-debit'

// Service: Notification
const MockDebugNotificationInvoices: MockDebug = {
  title: 'notification invoices',
  path: `${REACT_APP_CORE_API_URL}/companies/buyer/:companyId/invoices`,
  method: 'get',
  delay: 1500,
  options: [
    {
      id: 'mock-notification-one-invoice',
      title: 'one-invoice',
      status: 200,
      data: oneInvoice,
    },
  ],
}

// Service: Invoices
const MockDebugInvoicesInvoiceById: MockDebug = {
  title: 'Invoices By Id',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/invoice/:invoiceId`,
  method: 'get',
  delay: 1500,
  options: [
    {
      id: 'mock-invoices-one-installment',
      title: 'one-installment',
      status: 200,
      data: listOneInstallmentMock.source,
    },
    {
      id: 'mock-invoices-one-installment-without-service-fee',
      title: 'one-installment-without-service-fee',
      status: 200,
      data: listOneInstallmentWithoutServiceFeeMock.source,
    },
    {
      id: 'mock-invoices-all-status',
      title: 'all status',
      status: 200,
      data: listAllStatusMock.source,
    },
    {
      id: 'mock-invoices-edited',
      title: 'edited',
      status: 200,
      data: listEditedMock.source,
    },
    {
      id: 'mock-invoices-boleto-canceled',
      title: 'boleto canceled',
      status: 200,
      data: listBoletoCanceledMock.source,
    },
    {
      id: 'mock-invoices-boleto-download',
      title: 'boleto download',
      status: 200,
      data: listBoletoDownloadMock.source,
    },
    {
      id: 'mock-invoices-without-tax-number',
      title: 'boleto without tax number',
      status: 200,
      data: listWithoutTaxNumberMock.source,
    },
    {
      id: 'mock-invoices-debit',
      title: 'debit',
      status: 200,
      data: listDebitMock.source,
    },
    {
      id: 'mock-invoices-error-400',
      title: 'error 400',
      status: 400,
      data: genericErrorMock.source,
    },
    {
      id: 'mock-invoices-with-installment-reimbursed',
      title: 'invoice with installment reimbursed',
      status: 200,
      data: listReimbursedMock.source,
    },
  ],
}

const MockDebugInvoicesInvoicePDF: MockDebug = {
  title: 'PDF Invoice Download',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/nfe/pdf/:nfe_download_token`,
  method: 'get',
  delay: 1500,
  options: [
    {
      id: 'mock-invoices-pdf',
      title: 'Sucesso',
      status: 200,
      data: {
        url: 'https://example.com/download',
        file: 'invoice.pdf',
        base64: 'somebase64',
      },
    },
    {
      id: 'mock-invoices-pdf-error-400',
      title: 'error 400',
      status: 400,
      data: genericErrorMock.source,
    },
    {
      id: 'mock-invoices-pdf-error-500',
      title: 'error 500',
      status: 500,
      data: genericErrorMock.source,
    },
  ],
}

const MockDebugInvoicesBuyerInvoiceByIdCORE: MockDebug = {
  title: 'Invoices By Id(core)',
  path: `${REACT_APP_CORE_API_URL}/companies/:companyId/invoices/:invoiceId/buyer-status`,
  method: 'get',
  delay: 1500,
  options: [
    {
      id: 'mock-invoices-one-invoice',
      title: 'one-invoice',
      status: 200,
      data: listCoreOneInvoice,
    },
    {
      id: 'mock-invoices-pending-invoice',
      title: 'pending-invoice',
      status: 200,
      data: listCorePendingInvoiceInstallments,
    },
    {
      id: 'mock-invoices-one-installment',
      title: 'one-installment',
      status: 200,
      data: listCoreOneInstallment,
    },
    {
      id: 'mock-invoices-two-installments',
      title: 'two-installments',
      status: 200,
      data: listCoreTwoInstallments,
    },
    {
      id: 'mock-invoices-three-installments',
      title: 'three-installments',
      status: 200,
      data: listCoreThreeInstallments,
    },
    {
      id: 'mock-invoices-canceled',
      title: 'canceled',
      status: 200,
      data: listCoreCanceled,
    },
    {
      id: 'mock-invoices-edited',
      title: 'edited',
      status: 200,
      data: listCoreEdited,
    },
  ],
}

const MockDebugInvoicesBuyerSendPayApprove: MockDebug = {
  title: 'Send Pay Approve',
  path: `${REACT_APP_CORE_API_URL}/companies/:companyId/invoices/:invoiceId/pay-approve`,
  method: 'post',
  delay: 1500,
  options: [
    {
      id: 'mock-invoices-send-pay-approve',
      title: 'Success',
      status: 200,
      data: {},
    },
  ],
}

const MockDebugShowInvoice: MockDebug = {
  title: 'Invoice',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/invoices/:id`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-show-invoice-success',
      title: 'Success',
      status: 200,
      data: invoiceMock.build(),
    },
  ],
}

export const MockDebugInvoices = [
  MockDebugNotificationInvoices,
  MockDebugInvoicesInvoiceById,
  MockDebugInvoicesBuyerInvoiceByIdCORE,
  MockDebugInvoicesBuyerSendPayApprove,
  MockDebugShowInvoice,
  MockDebugInvoicesInvoicePDF,
]
